import { useGlobalDispatch } from "AppStore";
import { useDashboards } from "hooks/useDashboards";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const useSiteSetup = () => {
  const dispatch = useGlobalDispatch();

  const { site } = useParams<{
    site: string;
  }>();
  const { dashboards } = useDashboards(site);

  useEffect(() => {
    // set the global state with the dashboard read from fs and the layout
    if (dashboards) {
      dispatch({
        type: "SELECT_SITE",
        payload: {
          ...dashboards[0],
          type: window.innerWidth > window.innerHeight ? "WIDE" : "TALL",
        },
      });
    }
  }, [site, dispatch, dashboards]);
};

export default useSiteSetup;
